import { FiTrash2 } from "react-icons/fi"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"

import { deleteProfile } from "../../../../services/operations/SettingsAPI"

export default function DeleteAccount() {
  const { token } = useSelector((state) => state.auth)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  async function handleDeleteAccount() {
    try {
      dispatch(deleteProfile(token, navigate))
    } catch (error) {
      console.log("ERROR MESSAGE - ", error.message)
    }
  }

  return (
    <div className="my-6 md:my-10 flex flex-col md:flex-row gap-y-4 md:gap-x-5 rounded-md border-[1px] border-pink-700 bg-pink-900 p-4 md:p-8 md:px-12">
      <div className="flex aspect-square h-12 w-12 md:h-14 md:w-14 items-center justify-center rounded-full bg-pink-700 self-center md:self-start">
        <FiTrash2 className="text-2xl md:text-3xl text-pink-200" />
      </div>
      
      <div className="flex flex-col space-y-2">
        <h2 className="text-lg font-semibold text-richblack-5 text-center md:text-left">
          Delete Account
        </h2>
        
        <div className="w-full md:w-4/5 lg:w-3/5 text-pink-25 text-sm md:text-base">
          <p>Would you like to delete account?</p>
          <p className="mt-1">
            This account may contain Paid Courses. Deleting your account is
            permanent and will remove all the contain associated with it.
          </p>
        </div>
        
        <button
          type="button"
          className="w-fit mx-auto md:mx-0 cursor-pointer italic text-pink-300 mt-2 md:mt-0"
          onClick={handleDeleteAccount}
        >
          I want to delete my account.
        </button>
      </div>
    </div>
  )
}